import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  data: function data() {
    return {
      lang: "zh",
      loading: false,
      form: {
        zh: "",
        en: "",
        tw: ""
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getData: function getData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.loading = true;
              _context2.n = 1;
              return _this2.$api.getCityStrategyInfo({
                cityId: _this2.$route.query.id
              });
            case 1:
              res = _context2.v;
              _this2.form = res.data || {
                zh: "",
                en: "",
                tw: ""
              };
              _this2.loading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.form.cityId = _this3.$route.query.id;
              _context3.n = 1;
              return _this3.$api.updateCityStrategy(_this3.form);
            case 1:
              _this3.$message.success("操作成功");
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};